// #1667: editors keep forgetting to pick a captcha provider when adding a form,
// leaving it unprotected. New forms therefore default to Google ReCaptcha.
//
// The token matches plone.formblock's captcha provider vocabulary
// (`plone.formblock.captcha.providers`), where the recaptcha adapter is
// registered under the name "recaptcha".
export const DEFAULT_CAPTCHA_PROVIDER = 'recaptcha';

/**
 * Apply the default captcha provider to a form block's data without clobbering
 * an explicit choice. Spreading `value` last lets a captcha already set on the
 * block win over the default.
 */
export const applyCaptchaDefault = <T extends Record<string, any>>(
  value: T,
): T & { captcha: string } => ({
  captcha: DEFAULT_CAPTCHA_PROVIDER,
  ...value,
});
